import styled from 'styled-components';
import { ConsolePanel } from '@/ui/ConsolePanel/ConsolePanel';

export const ComposerFrame = styled(ConsolePanel)<{ $overlay?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  min-width: 0;
  [data-identity] > [role='img'] {
    border-radius: 50%;
  }
  ${({ $overlay }) =>
    $overlay &&
    `padding: 0; border: 0; background: transparent; box-shadow: none; backdrop-filter: none;`}
  &[data-overlay='true'] textarea {
    min-height: 152px;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme.color.glassBorder};
    border-radius: ${({ theme }) => theme.radius.md};
    background: ${({ theme }) => theme.color.surface};
  }
  &[data-overlay='true'] [data-tools] {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 8px;
  }
  &[data-overlay='true'] [data-tools] > * {
    min-width: 0;
  }
  &[data-overlay='true'] [data-tools] [data-composer-tool] {
    width: 100%;
    min-height: 68px;
    padding: 8px 3px;
    flex-direction: column;
    gap: 8px;
  }
  @media (max-width: 560px) {
    &[data-overlay='true'] [data-tools] {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
`;

// Exported so tests can target the outer wrapper regardless of auth state.
ComposerFrame.displayName = 'ComposerWrap';
